<template>
  <div class="real-container">
    <top-nav :shrinked="true"/>
    <img class="banner page-banner" src="@/assets/real/banner.jpg">
    <div class="site-text__content">
      <h3 class="text-blue site-text__content_h3">以人为本 社区共生</h3>
      <div class="site-text__content_desc">
        <p>致力于满足客户在居住生活中的多元化需求</p>
      </div>
    </div>
    <div class="site-text__content" style="padding-top:0;padding-bottom:30px;">
      <h3 class="text-blue site-text__content_h3">品牌故事</h3>
    </div>
    <div class="full_content">
      <div class="video-item video__self">
        <video
                id="video1"
                class="hotel-video-class video-color"
                webkit-playsinline="true"
                x-webkit-airplay="true"
                playsinline="true"
                x5-video-player-type="h5"
                preload='auto'
                poster="@/assets/real/poster_1.png"
                loop>
          <source src="@/assets/real/video1.mp4" type="video/mp4">
        </video>
        <div v-if="video" class="video-btn wy-video-btn" @click="videoClick('video1')"></div>
      </div>
      <div class="middle-container middle-container_min">
        <div class="middle_content_item middle_content_item_min" style="text-align:center;">
          <span>90%</span>
          <span class="bottom_span">+</span>
          <div>连续18年客户满意度</div>
        </div>
        <div class="middle_line"></div>
        <div class="middle_content_item middle_content_item_min">
          <span>33</span>
          <span class="bottom_span">+</span>
          <span style="margin-left:0;">个</span>
          <div>物业在管项目</div>
        </div>
        <div class="middle_line"></div>
        <div class="middle_content_item middle_content_item_min" style="text-align:center;">
          <span>500万</span>
          <span class="bottom_span">+</span>
          <span style="margin-left:2px;">平米</span>
          <div>物业在管面积</div>
        </div>
      </div>

      <div class="site-text__content ls__content" style="padding-top:0;padding-bottom:40px;">
        <h3 class="text-blue site-text__content_h3">深度物业服务</h3>
      </div>
      <div class="wy-container">
        <div class="wy-icon-container">
          <div v-for="(item,index) in fwList" :key="index" class="wy-icon-item">
            <div v-if="item.name.length>0">
              <img :src="require('@/assets/real/' + item.img)"/>
              <div class="text">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="multi-content NioHouseFunction_nioHouseFunctionContainer__Slqkp">
        <div class="multi-slider multi-slider_content">
          <div v-for="(item,index) in wyList" :key="index">
            <div class="multi-slider_item multi-slider_item__radius">
              <img :src="require('@/assets/real/' + item.img)"/>
              <div class="multi-slider_bottom_text text-center">
                {{item.name}}
              </div>
            </div>
          </div>
        </div>
        <div class="Carousel_carouselControls__HecEP carouselControls">
          <div v-if="!isMobile" class="Carousel_carouselArrowWrapper__7vECO" @click="carouseClick('prev')">
            <div class="Carousel_carouselArrow__YV3L6 carouselArrowPrev">
              <i></i>
              <i></i>
            </div>
          </div>
          <div class="Carousel_carouselPagination__dClSG carouselPagination">
                    <span v-for="(item,index) in wyList" :key="index"
                          class="Carousel_carouselPaginationItem__g0Rld carouselPaginationItem"
                          :class="{'Carousel_carouselPaginationActive__fh9Dk carouselPaginationActive':currentSlide1===index}">
                    </span>
          </div>
          <div v-if="!isMobile" class="Carousel_carouselArrowWrapper__7vECO" @click="carouseClick('next')">
            <div class="Carousel_carouselArrow__YV3L6 Carousel_carouselArrowNext__o36BS carouselArrowNext">
              <i></i>
              <i></i>
            </div>
          </div>
        </div>
      </div>

      <div class="site-text__content ls__content">
        <h3 class="text-blue site-text__content_h3">服务版图</h3>
      </div>
      <div class="service_mode">
        <div class="left_mode">
          <img src="@/assets/real/icon_pic.png">
          <div>
            <p>用心呵护 品质生活</p>
            <p>● 江苏省房地产协会理事单位</p>
            <p>● 常州物业管理协会副会长单位</p>
            <p>● 省级优秀千里示范项目</p>
            <p>● 市级优秀管理示范项目</p>
          </div>
        </div>
        <div class="right_mode">
          <img src="@/assets/real/map_bg.png">
        </div>
      </div>

      <div class="site-text__content ls__content">
        <h3 class="text-blue site-text__content_h3">温馨时刻</h3>
      </div>
      <div class="wx_mode">
        <div class="wx_mode_slider">
          <div class="slider" dir="ltr" >
            <div v-for="(item,index) in wxList" :key="index" >
              <div class="wx_mode_slider_item">
                <img :src="require('@/assets/real/' + item.imgUrl)" draggable="false">
                <div class="wx_mode_slider_text">
                  {{item.name}}
                </div>
              </div>
            </div>
          </div>
          <div class="wx_mode_slider_pagination">
              <span v-for="(item,index) in wxList" :key="index"
                    class="wx_mode_slider_pagination_bg"
                    @click="paginationClick(index)">
                <span class="wx_mode_slider_pagination_item">
                  <span class="wx_mode_slider_pagination_line" :style="currentSlide === index?'width: 100%; transition: width 5s ease-in;':'width: 0%; transition: none;'">
                  </span>
                </span>
              </span>
          </div>
        </div>
      </div>
    </div>
    <div class="real-honor_container">
      <div class="site-text__content ls__content">
        <h3 class="text-blue site-text__content_h3">荣誉实力</h3>
      </div>
      <div class="display-row real-honor_content">
<!--        <img src="@/assets/hotel/aa.png">-->
        <div v-for="(item,index) in 4" :key="index" class="real-honor_item">
          <img :src="require('@/assets/real/honor_bg'+(index+1)+'.png')">
<!--          <div class="text">江苏省房地产协会理事单位</div>-->
        </div>
      </div>
    </div>
    <div class="contact-content">
      <div class="contact-bg">
        <h3 class="mode-title">联系我们</h3>
        <div class="text-up contact-en">contact us</div>
        <div class="bottom-address">
          <div>
            <p>集团总部地址：江苏省常州市延陵西路19号嘉宏世纪大厦33楼</p>
            <p>邮编：213000</p>
            <p>联系电话：0519-88160137</p>
            <p>传真：0519-88160137</p>
            <p>400服务监督热线：4008289980（工作时间:周一至周五8:30-17:30）</p>
          </div>
          <div class="address-right">
            <p>E-mail：jiahongfangchan@163.com </p>
            <p>人事招聘邮箱：hr@jiahonggroup.com</p>
            <p>联系电话：0519-88160131</p>
            <p>招商电话：0519-86807766</p>
            <p>招投标电话：0519-88162912</p>
          </div>
        </div>
        <h3 class="mode-title" style="margin-top:20px;">联系地址</h3>
        <div class="text-up contact-en">contact address</div>
        <div class="bottom-address big-address col-000">
          江苏省常州市延陵西路19号嘉宏世纪大厦33楼
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import topNav from '@/components/base/top-nav'
  import $ from 'jquery';
  var that = null
  export default {
    name: "real",
    components:{
      topNav
    },
    data() {
      return {
        video:true,
        isMobile:false,
        currentSlide1: 0,
        currentSlide: -1,
        fwList:[
          {
            img:'zx.png',
            name:'尊享+'
          },
          {
            img:'gh.png',
            name:'关怀+'
          },
          {
            img:'sy.png',
            name:'素养+'
          },
          {
            img:'',
            name:''
          },
          {
            img:'zn.png',
            name:'智能+'
          },
          {
            img:'gx.png',
            name:'个性+'
          },
          {
            img:'ll.png',
            name:'邻里+'
          }
        ],
        wyList:[
          {
            img:'swiper1.png',
            name:'省心安心 守护生活'
          },
          {
            img:'swiper2.png',
            name:'大美焕新 每日相遇'
          },
          {
            img:'swiper3.png',
            name:'创造标杆 服务尊崇'
          },
          {
            img:'swiper4.png',
            name:'真诚善达 温暖相伴'
          },
          {
            img:'swiper5.png',
            name:'便捷享受 传递美好'
          },
          {
            img:'swiper6.png',
            name:'时光共赏 全龄乐活'
          }
        ],
        wxList:[
          {
            imgUrl:'wx1.jpg',
            name:'雅致图书馆'
          },
          {
            imgUrl:'wx2.jpg',
            name:'节日主题活动'
          },
          {
            imgUrl:'wx3.jpg',
            name:'主题沙龙'
          },
          {
            imgUrl:'wx4.jpg',
            name:'技能大赛'
          },
        ]
      }
    },
    mounted() {
      that = this
      this.initSlider()
      this.handleResize()
    },
    methods: {
      handleResize(){
        this.isMobile = window.innerWidth <= 720
      },
      videoClick(videoId){
        var video = document.getElementById(videoId);
        // video.addEventListener('pause', function() {
        //   that.video = true
        //   video.controls = false;
        // });
        video.play();
        that.video = false
        video.controls = true;
      },
      /**
       * 初始化轮播
       */
      initSlider() {
        this.$nextTick(() => {
          $('.multi-slider').slick({
            arrows: false,
            initialSlide: 0,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  arrows: false,
                  draggable:true,
                }
              },
              {
                breakpoint: 721,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  draggable:true,
                }
              }
            ]
          });
          $('.multi-slider').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
            that.currentSlide1 = currentSlide
          });

          // 温馨时刻
          $('.slider').slick({
            arrows: false,
            dots: false,
            fade: true,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            pauseOnHover: false
          });
          that.currentSlide = 0
          //自动轮播
          $('.slider').on('beforeChange', function pauseSlideShow(event, slick, currentSlide,nextSlide) {
            that.currentSlide = nextSlide
          });
        });
      },
      /**
       * 轮播切换
       * @param index
       */
      paginationClick(index){
        $('.slider').slick('slickGoTo', index);
        // 重置动画
        that.currentSlide = index
      },
      carouseClick(type){
        if(type == 'prev'){
          $(".multi-slider").slick("slickPrev");
        }else{
          $(".multi-slider").slick("slickNext");
        }
      },
    }
  }
</script>

<style>
  @import "../../styles/real.css";
  @import "../../styles/service.css";
</style>
